import React from "react";
import "../../resources/scss/infoBanner/infoBanner.scss";

interface Props {
  isOpen: boolean;
  onClose: (e: any) => void;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

function InfoBanner({
  isOpen,
  onClose = () => {},
  children,
  style = {},
}: Props) {
  if (!isOpen) return null;
  return (
    <div
      className="common-info-banner_cmBannerContainer"
      style={{...style}}
    >
      <div className="common-info-banner_cmBannerElements">{children}</div>

      <div className="common-info-banner_icon" onClick={onClose}>
        <div className="commonInfoBanner-circle-close">
          <span className="commonInfoBanner-x" aria-hidden="true"></span>
        </div>
      </div>
    </div>
  );
}

export default InfoBanner;
